import { useQuery } from "@tanstack/react-query";
import { Buffer } from "buffer";
import { useEffect } from "react";
import { ExternalAppToken, getVisitToLeadToolToken } from "../api/visitToLeadTool";

const TOKEN_REFRESH_INTERVAL = 60 * 60 * 1000;

// Fetches the external app token, refreshes it hourly and builds the Streamlit iframe url.
export const useStreamlitEmbedUrl = (queryKey: string, baseUrl: string) => {
  const {
    data: tokenData,
    isFetching,
    refetch,
  } = useQuery<ExternalAppToken>({ queryKey: [queryKey], queryFn: getVisitToLeadToolToken, enabled: false });

  useEffect(() => {
    refetch();
    const interval = setInterval(() => refetch(), TOKEN_REFRESH_INTERVAL);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [refetch]);

  // `id` is appended unencoded to match what the Streamlit apps already parse
  const encodedToken = tokenData?.token ? Buffer.from(tokenData.token).toString("base64") : "";

  let iframeUrl = baseUrl;
  if (encodedToken) iframeUrl += `&id=${encodedToken}`;
  if (tokenData?.user_token) iframeUrl += `&user_token=${encodeURIComponent(tokenData.user_token)}`;

  return { iframeUrl, isFetching };
};
